var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4349",
    "data-name": "Rectangle 4349",
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7855",
    "data-name": "Group 7855"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_171",
    "data-name": "Ellipse 171",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(7 -1)",
    fill: "#FFCC00",
    stroke: "#FFCC00",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25315",
    "data-name": "Path 25315",
    d: "M23,13H7a1,1,0,0,0,0,2h5.95v5l-2.4,7.7a1,1,0,0,0,.65,1.25h.3a1,1,0,0,0,.95-.7L14.9,20.5h.2l2.45,7.8a1,1,0,0,0,.95.7h.3a1,1,0,0,0,.65-1.25L17.05,20V15H23a1,1,0,0,0,0-2Z",
    transform: "translate(-6 -8)",
    fill: "#FFCC00",
    stroke: "#FFCC00",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManIcon);
export default __webpack_public_path__ + "static/media/ManIcon.43cd1a1ba1a7e799dcc68291317b75dd.svg";
export { ForwardRef as ReactComponent };